import React, { useState } from "react";
import { Helmet } from "react-helmet";
import CoursesData from "../content.json";
import { BsLightningFill } from "react-icons/bs";
import Courses from "../Components/Courses";

function ITEP() {
  const [ITEPData] = useState(CoursesData.Courses[2]);
  return (
    <>
      <Helmet>
        <title>ITEP (Foundation) | University of Education</title>
      </Helmet>
      <div className="PageContainer">
        <div className="">
          <div id="Heading" className="CourseTitle" data-aos="fade-up">
            <h1>{ITEPData.course_fullname}</h1>
          </div>
          <div className="RecognitionBanner" data-aos="fade-up" style={{
            background: "linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)",
            borderLeft: "6px solid #fb8c00",
            padding: "20px",
            borderRadius: "8px",
            marginBottom: "30px",
            boxShadow: "0 4px 15px rgba(0,0,0,0.05)"
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: "12px", color: "#e65100", fontWeight: "700", fontSize: "1.1rem", marginBottom: "8px" }}>
              <BsLightningFill size={24} /> STATUS: (In Recognition Process)
            </div>
            <p style={{ margin: 0, color: "#5d4037", opacity: 0.9 }}>
              This course is currently undergoing the official recognition and approval process.
            </p>
          </div>

          <div className="UnitsGrid" data-aos="fade-up" style={{ marginBottom: "40px" }}>
            <h3 style={{ borderBottom: "2px solid #eee", paddingBottom: "10px", marginBottom: "20px", color: "#333" }}>Approved Units</h3>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "15px" }}>
              {[
                "01 Unit B.A. B.Ed.",
                "01 Unit B.Sc. B.Ed.",
                "01 Unit B.Com. B.Ed."
              ].map((unit, index) => (
                <div key={index} style={{ 
                  display: "flex", 
                  gap: "12px", 
                  alignItems: "center", 
                  padding: "15px 20px",
                  backgroundColor: "#ffffff",
                  borderRadius: "10px",
                  border: "1px solid #e0e0e0",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.02)",
                  transition: "transform 0.2s ease"
                }}>
                  <div style={{ backgroundColor: "#fff8e1", padding: "8px", borderRadius: "50%", display: "flex" }}>
                    <BsLightningFill style={{ color: "#ffa000" }} />
                  </div>
                  <span style={{ fontWeight: "600", color: "#444" }}>{unit}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="CourseDetailsContainer" data-aos="fade-up">
            <div id="Secondary_Heading">
              <h3>Course Detail</h3>
            </div>
            <div className="CourseTable">
              <table>
                <tbody>
                  <tr>
                    <td>Course -</td>
                    <td>{ITEPData.course_fullname}</td>
                  </tr>
                  <tr>
                    <td>Certificate -</td>
                    <td>{ITEPData.course_certification}</td>
                  </tr>
                  <tr>
                    <td>Duration -</td>
                    <td>{ITEPData.course_duration}</td>
                  </tr>
                  <tr>
                    <td>No. of Semester -</td>
                    <td>{ITEPData.course_sem}</td>
                  </tr>
                  <tr>
                    <td>Seats -</td>
                    <td>3 Units (01 Unit B.A. B.Ed., 01 Unit B.Sc. B.Ed., 01 Unit B.Com. B.Ed.)</td>
                  </tr>
                  <tr>
                    <td>Eligibility -</td>
                    <td>{ITEPData.course_eligibility}</td>
                  </tr>
                  <tr>
                    <td>Fees -</td>
                    <td>(In Recognition Process)</td>
                  </tr>
                  <tr>
                    <td>University -</td>
                    <td>{ITEPData.university}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <section>
            <Courses />
          </section>
        </div>
      </div>
    </>
  );
}

export default ITEP;
